import React from "react";

const formatValues = (value) => {
  return value.replaceAll("|", ", ");
};

export default function AdditionalColumnTDs(props) {
  if (!props.columns?.length > 0 || !props.collection?.length > 0) {
    return null;
  }

  // Render the data inside the <td> based on the group and collection
  const renderGroupData = (group) => {
    const hasMultipleValues = group.values?.length > 1;
    const sortedValues = group.values?.sort((a, b) => a - b).join(" / ");

    const displayValue = hasMultipleValues
      ? sortedValues
      : group.values?.length === 1
        ? formatValues(group.values[0])
        : "";

    return `${displayValue} ${group.fieldUnit || ""}`.trim();
  };

  return props.columns?.map((column) => {
    const match = props.collection.filter((x) => x.fieldName === column.id)[0];
    const multi = column.values?.length > 1;

    if (!match) {
      return (
        <td className="c-parts-listing__table-item" key={column.id}>
          -
        </td>
      );
    }

    return (
      <td className={`c-parts-listing__table-item ${multi ? "multi" : ""}`} key={column.id}>
        <span className="c-parts-listing__label">{match.fieldHeader}</span>
        {/* {(multi ? match.values.sort((a, b) => a - b).join(" / ") : match.values[0]) + " " + match.fieldUnit} */}
        {renderGroupData(match)}
      </td>
    );
  });
}
